import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { FANCOIL_MODE_SHOW_STATUS_MANUAL } from 'src/environments/environment';

@Component({
  selector: 'app-modal-view-fancoil-mode',
  templateUrl: './modal-view-fancoil-mode.component.html',
  styleUrl: './modal-view-fancoil-mode.component.scss'
})
export class ModalViewFancoilModeComponent {
  @Input({required: true}) controllers: Controller[];
  updated: Date;
  updatePipeSubscription: Subscription;
  Property = Property;
  FANCOIL_MODE_SHOW_STATUS_MANUAL = FANCOIL_MODE_SHOW_STATUS_MANUAL;
  icon = 'icon-fan';
  text = 'Fancoil mode';

   constructor(
      private projectService: ProjectService,
    ) { }

   ngOnInit(): void {
    this.updatePipeSubscription = this.projectService.updatedPipe$.subscribe( value => {
      this.updated = new Date()
    })
  }

  ngOnDestroy(){
      if(this.updatePipeSubscription) {
        this.updatePipeSubscription.unsubscribe();
      }
    }
}


